/**
 * 樂觀更新通用工具（複製自 pm-frontend/src/utils/storeHelpers.ts）
 */

export function createOptimisticDelete<T extends { id: string }>(
  arrayKey: string,
  _entityName: string
) {
  return async function optimisticDelete(
    id: string,
    deleteFn: (id: string) => Promise<any>,
    get: () => any,
    set: (partial: any) => void
  ): Promise<void> {
    const state = get();
    const originalArray = [...state[arrayKey]] as T[];

    // 1. 立即移除（樂觀更新）
    set({ [arrayKey]: state[arrayKey].filter((item: T) => item.id !== id) });

    try {
      await deleteFn(id); // 2. 背景 API
    } catch (error: any) {
      set({ [arrayKey]: originalArray }); // 3. 失敗回滾
      throw error;
    }
  };
}
